import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'theme/color-palette';
const { LIGHT_GRAY_SHADE, FONT_COLOR, GREY, PURPLE, WHITE, LIGHT_PURPLE } = colors;
import { Bogle_Medium, Bogle_Regular } from 'constants/constant';

const removeAccessMenuStyle = makeStyles(() => ({
	menu: {
		width: '160px !importnant'
	},
	menuItems: {
		'&:hover': {
			background: LIGHT_GRAY_SHADE
		},
		color: FONT_COLOR,
		padding: '8px 16px'
	},
	menuIcon: {
		marginRight: '12px',
		height: '18px',
		width: '18px',
		visibility: 'visible'
	},
	menuLabel: {
		fontSize: '14px'
	},
	filterIcon: {
		'&:hover': {
			cursor: 'pointer',
			background: LIGHT_GRAY_SHADE
		}
	},
	crossIcon: {
		color: GREY,
		alignItems: 'center',
		'& .MuiSvgIcon-root': {
			width: '14px'
		}
	},
	userDetail: {
		padding: '8px 0px'
	},
	userNameLabel: {
		fontSize: '16px',
		lineHeight: '20px',
		color: FONT_COLOR,
		fontFamily: `${Bogle_Regular} !important`
	},
	userLoginIdLabel: {
		fontSize: '12px',
		lineHeight: '16px',
		color: FONT_COLOR,
		fontFamily: `${Bogle_Regular} !important`
	},
	userAccessLabel: {
		textAlign: 'end',
		fontSize: '12px',
		lineHeight: '16px',
		color: FONT_COLOR,
		fontFamily: `${Bogle_Regular} !important`
	},
	hideButton: {
		display: 'none'
	},
	hideIcon: {
		visibility: 'hidden'
	},
	dialogContainer: {
		minWidth: '444px',
		padding: 16
	},
	dialogContentPadding: {
		padding: '8px 16px 8px 16px'
	},
	dialogContent: {
		fontSize: 16,
		fontFamily: `${Bogle_Medium} !important`,
		color: FONT_COLOR
	},
	dialogActionBtnPadding: {
		padding: '8px 16px 16px 16px'
	},
	button: {
		height: 40,
		textTransform: 'none',
		fontSize: 14,
		borderRadius: 20,
		marginLeft: '16px !important',
		width: 135,
		fontWeight: 600,
		color: PURPLE,
		fontFamily: Bogle_Medium,
		cursor: 'pointer'
	},
	applyBtn: {
		background: PURPLE,
		color: WHITE,
		'&:hover': {
			backgroundColor: LIGHT_PURPLE
		}
	},
	continueBtn: {
		display: 'flex',
		border: '1px solid',
		'&:hover': {
			color: WHITE,
			backgroundColor: LIGHT_PURPLE
		}
	},
	bulletStyle: {
		height: '3px',
		paddingRight: '4px',
		paddingLeft: '4px',
		verticalAlign: 'middle'
	},
	recipeOnlyTitle: {
		fontSize: '12px',
		fontWeight: '500',
		color: GREY
	}
}));

export default removeAccessMenuStyle;
